import React from 'react';
import { withPrefix } from 'gatsby';
import * as styles from './Image.module.css';

interface ImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  aspectRatio?: string;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  loading?: 'lazy' | 'eager';
}

const Image: React.FC<ImageProps> = ({
  src,
  alt = "画像",
  className = "",
  width,
  height,
  aspectRatio,
  objectFit = 'cover',
  loading = 'lazy'
}) => {
  const imageStyles: React.CSSProperties = {
    width,
    height,
    aspectRatio,
    objectFit,
  };

  return (
    <img
      src={withPrefix(src)}
      alt={alt}
      className={styles.image + " " + className}
      style={imageStyles}
      loading={loading}
    />
  );
};

export default Image;
